import { ItpRfqContextQuery_quotesForRfq as LimitedQuote } from '../../../context/types/ItpRfqContextQuery';

export const sortQuotesByDate = (quotes: LimitedQuote[]) =>
  [...quotes].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return dateB.getTime() - dateA.getTime();
  });
